import 'bootstrap/js/dist/collapse.js';
import ValidatedFormView from '../form/ValidatedFormView.js';
import $ from 'jquery';
// import '../form/FormControlHelp';

const FORM_PREFIX = 'tx_jobs_cammioapplicationform[form]';

export class CammioApplicationForm extends ValidatedFormView {
  constructor(options) {
    super(Object.assign({
      formName: 'CammioApplicationForm',
      validations: {
        [`${FORM_PREFIX}[anrede]`]: ['required', 'isIntNotZero'],
        [`${FORM_PREFIX}[vorname]`]: ['required', 'forename'],
        [`${FORM_PREFIX}[nachname]`]: ['required', 'lastname'],
        [`${FORM_PREFIX}[anschrift]`]: ['required'],
        [`${FORM_PREFIX}[plz]`]: ['required'],
        [`${FORM_PREFIX}[ort]`]: ['required', 'city'],
        [`${FORM_PREFIX}[geburtsdatum]`]: ['required', 'dateNotInFuture'],
        [`${FORM_PREFIX}[telefonFestnetz]`]: ['required', 'phone'],
        [`${FORM_PREFIX}[email]`]: ['required', 'email'],
      },
    }, options));

    this.disableHtmlFormValidation();
    this.scrollToErrorMessage();
  }

  disableHtmlFormValidation() {
    this.$form[0].noValidate = true;
  }
}
